import {
  Show,
  SimpleShowLayout,
  TextField,
  NumberField,
  TopToolbar,
  EditButton,
  Button,
  useRecordContext,
} from "react-admin";
import DisplayDateField from "@/components/DisplayDateField";
import DownloadIcon from "@mui/icons-material/Download";
import type { ShowProps } from "react-admin";
import { openProjectTakhmeenReceiptPrint } from "./project-takhmeen-receipt-utils";

const ShowActions = () => {
  const record = useRecordContext();
  return (
    <TopToolbar>
      {record?.id ? (
        <Button label="Print" onClick={() => openProjectTakhmeenReceiptPrint(record.id)}>
          <DownloadIcon />
        </Button>
      ) : null}
      <EditButton />
    </TopToolbar>
  );
};

export const ProjectTakhmeenReceiptShow = (props: ShowProps) => (
  <Show {...props} actions={<ShowActions />}>
    <SimpleShowLayout>
      <TextField source="receiptNo" emptyText="—" />
      <NumberField source="amount" options={{ style: "currency", currency: "INR" }} />
      <TextField source="paymentMode" />
      <TextField source="paymentRef" emptyText="—" />
      <DisplayDateField source="receiptDate" />
      <TextField source="remarks" emptyText="—" />
    </SimpleShowLayout>
  </Show>
);
